<template>
  <Word
    v-bind="bindProps"
    :bgImg="require('@/assets/word_house.png')"
    :bgMask="require('@/assets/word_house_mask.svg')"
    v-on="$listeners"
    :class="$style.word"
  >
    <div :class="$style.display" v-html="wordSvg"></div>
  </Word>
</template>

<script>
import wordMixin from '@/mixins/word'

export default {
  mixins: [wordMixin()],
  computed: {
    wordSvg () {
      const svg = this.word.svg
      return require(`!svg-inline-loader?classPrefix!@/assets/svg/right-word/${svg}`)
    },
  },
}
</script>

<style lang="scss" module>
$width: 10rem;
$height: 10rem;

.word {
  width: $width;
  height: $height;
  @apply mx-4;
  @apply my-4;
}

.display {
  @apply pt-6;
  width: 5.5rem;
  height: 5.5rem;
}
</style>
